const log = {
    invalid_type: 'The log type is invalid.',
    invalid_time_window: '`end_time` must be after `start_time`.',
};
export default Object.freeze(log);
